import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { API, apiError, area, authHeaders, input, lbl, primaryBtn } from "./ambassadorApi";
import { ChannelsEditor } from "./ChannelsEditor";

export const SupportForm = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/ambassadors/me/support`, { subject, message }, { headers: authHeaders() });
      toast.success("Sent — we'll reply to your email.");
      setSubject(""); setMessage("");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form data-testid="amb-support-form" onSubmit={submit} className="space-y-4">
      <div><label htmlFor="amb-support-subject" className={lbl}>Subject</label><input id="amb-support-subject" data-testid="amb-support-subject" className={input} value={subject} onChange={(e) => setSubject(e.target.value)} required minLength={2} placeholder="Payout question, link not tracking, content ideas…" /></div>
      <div><label htmlFor="amb-support-message" className={lbl}>Message</label><textarea id="amb-support-message" data-testid="amb-support-message" className={area} value={message} onChange={(e) => setMessage(e.target.value)} required minLength={5} /></div>
      <button type="submit" data-testid="amb-support-submit" disabled={busy} className={primaryBtn}>{busy ? <Loader2 size={14} className="animate-spin" /> : null} Send to the Deen District team</button>
    </form>
  );
};

export const ProfileForm = ({ amb, onSaved }) => {
  const [f, setF] = useState({ name: amb.name, phone: amb.phone || "", country: amb.country || "", city: amb.city || "", paypal_email: amb.paypal_email || "", audience: amb.audience || "", about: amb.about || "", channels: amb.channels?.length ? amb.channels : [{ platform: "instagram", handle: "" }] });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.put(`${API}/ambassadors/me`, { ...f, channels: f.channels.map((c) => ({ ...c, followers: c.followers || null })) }, { headers: authHeaders() });
      onSaved(r.data);
      toast.success("Profile saved");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form data-testid="amb-profile-form" onSubmit={submit} className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <div><label className={lbl}>Full name</label><input data-testid="amb-profile-name" className={input} value={f.name} onChange={set("name")} required minLength={2} /></div>
        <div><label className={lbl}>PayPal email</label><input data-testid="amb-profile-paypal" type="email" className={input} value={f.paypal_email} onChange={set("paypal_email")} required /></div>
        <div><label className={lbl}>Phone / WhatsApp</label><input data-testid="amb-profile-phone" className={input} value={f.phone} onChange={set("phone")} /></div>
        <div><label className={lbl}>Country</label><input data-testid="amb-profile-country" className={input} value={f.country} onChange={set("country")} /></div>
        <div><label className={lbl}>City</label><input data-testid="amb-profile-city" className={input} value={f.city} onChange={set("city")} /></div>
        <div><label className={lbl}>Who follows you?</label><input data-testid="amb-profile-audience" className={input} value={f.audience} onChange={set("audience")} /></div>
      </div>
      <div><p className={lbl}>Where you promote</p><ChannelsEditor channels={f.channels} onChange={(channels) => setF({ ...f, channels })} /></div>
      <div><label className={lbl}>About you</label><textarea data-testid="amb-profile-about" className={area} value={f.about} onChange={set("about")} /></div>
      <button type="submit" data-testid="amb-profile-save" disabled={busy} className={primaryBtn}>{busy ? <Loader2 size={14} className="animate-spin" /> : null} Save changes</button>
    </form>
  );
};
